export default {
  titles: {
    title: 'Administrador de soportes',
    pending: 'Soportes faltantes',
    received: 'Soportes subsanados',
  },
  filters: {
    search: 'Buscar por nombre de cargo o ID referente',
    relation: 'Nivel de relación'
  },
  grid: {
    supportFileCode: 'Soporte',
    fileName: 'Nombre de archivo',
    supportName: 'Nombre de soporte',
    accountRelation: 'Evento',
    chargeRelation: 'Descripción del Cargo',
    accountLevelDocument: 'Cargo no relacionado',
    nonPatientFound: 'Información no disponible',
    patient: 'Nombre del paciente',
    relation: 'Nivel de relación',
    referenceId: 'ID referente',
    upload: 'Cargar',
    actions: 'Acciones',
    uploadedFile: 'Archivo cargado',
    required: 'Requerido',
    AiAnalysis: 'Análisis de IA',
  },
  AiAnalysis: {
    tooltipHeader: `La IA analiza el documento y verifica si los datos son correctos y tienen sentido. 
    El estado indica el resultado y el nivel de confianza de esta lectura.`,
    tooltipApproved: '¡Todo correcto! No se identificó ninguna discrepancia.',
    tooltipRejected: 'Se identificaron discrepancias. Haga clic para ver los detalles.',
    tooltipPending: 'El análisis de IA está siendo procesado, aguarde unos instantes.',
    noAiAnalysis: 'No hay análisis de IA disponible',
    aiStatus: {
      approved: 'Aprovado',
      rejected: 'Reprovado',
      pending: 'Procesando'
    }
  },
  relations: {
    account: 'Cuenta',
    charge: 'Cargo',
    event: 'Evento',
    authorization: 'Autorización',
  },
  labels: {
    charge: 'Cargo',
    dragAndDrop: 'Arrastra y suelta el archivo aquí',
    uploadFile: 'Cargar archivo',
    deleteFile: 'Desea eliminar soporte?'
  },
  actions: {
    upload: 'Agregar Soporte',
    replace: 'Reemplazar Soporte',
    changeFile: 'Cambiar archivo',
    uploadInformation: 'Información de soporte',
    accept: 'Aceptar',
    cancel: 'Cancelar',
    downloadSelected: 'Descargar seleccionados',
  },
  required: {
    yes: 'SI',
    no: 'NO'
  },
  errors: {
    downloadSelectedError: 'Error al descargar los archivos seleccionados',
  },
}
